import LdfView from '@features/creation/ldf/components/LdfView'
import { requirePermission } from '@lib/permissions/guards'
import { createFileRoute } from '@tanstack/react-router'
import { Eye } from 'lucide-react'

export const Route = createFileRoute('/_app/creation/ldf/$id/view')({
  loader: requirePermission('creation.ldf.view'),
  staticData: {
    title: 'Détails LDF',
    icon: Eye,
    permission: 'creation.ldf.view',
    section: 'Creation',
    showInBreadcrumb: true,
  },
  component: ViewLdfPage,
})

function ViewLdfPage() {
  return <LdfView />
}